import { Box, Tooltip } from '@mui/material'
import React from 'react'
import VerifiedIcon from '@mui/icons-material/Verified'
import theme from '../../../../../theme'
import { blue, grey } from '../../../../../colors'

interface SchoolApprovedBadgeProps {
  isSurveyTemplate?: boolean
  isApproved: boolean | undefined
  onClick?: (isSchoolApproved: boolean) => void
}

const SchoolApprovedBadge: React.FC<SchoolApprovedBadgeProps> = ({ isSurveyTemplate = false, isApproved, onClick }): JSX.Element => {
  const tooltipText = isSurveyTemplate
    ? 'Approved questions become available for instructors or academic units to include in their surveys. Click to change.'
    : 'You do not have permission to edit school-approved survey questions.'
  const iconColor = (isApproved ?? !isSurveyTemplate) ? blue[400] : grey[150]

  return (
    <Tooltip
      title={
        <Box sx={{ maxWidth: theme.spacing(60), fontSize: theme.typography.body2.fontSize, p: theme.spacing(1) }}>
          {tooltipText}
        </Box>
      }
      placement='top'
      arrow
    >
      <Box
        display='flex'
        flexDirection='row'
        sx={{
          ...(isSurveyTemplate ? { ':hover .icon': { opacity: 0.5 } } : {}),
          cursor: 'pointer',
          mx: theme.spacing(1)
        }}
        onClick={() => {
          if (isSurveyTemplate) {
            onClick?.(!isApproved)
          }
        }}
      >
        <VerifiedIcon
          className='icon'
          sx={{ color: iconColor }}
        />
        <Box
          ml={theme.spacing(1)}
          fontWeight='bold'
          sx={{
            ':hover': { opacity: 1 }
          }}
        >
          School Approved
        </Box>
      </Box>
    </Tooltip>
  )
}

export default SchoolApprovedBadge
